import { getCurrentFormSchemaVersionsRogerdocFormSchemasCurrentGet } from '../../services/api/sdk.gen';
import type { FormSchemaVersion } from '../../services/api/types.gen';
import type { VisitTypeId } from '../../services/api/models/VisitTypeId';

/**
 * Forms Manager schema-version list: Roger EMR only.
 * Always passes emr_type=rogeremr so RogerDoc filters WellSky/Kinnser-only rows
 * at the catalog boundary (callers cannot forget the param).
 */
export async function fetchRogerEmrFormSchemaVersions(
  visitType: VisitTypeId,
  options?: { signal?: AbortSignal }
): Promise<FormSchemaVersion[]> {
  const res = await getCurrentFormSchemaVersionsRogerdocFormSchemasCurrentGet({
    query: { visit_type: visitType, emr_type: 'rogeremr' },
    signal: options?.signal,
    throwOnError: true,
  });
  return res.data ?? [];
}
